import { Tooltip, TooltipCoordinator } from '@frontapp/ui-kit';

export default function Ellipsis({
  content,
  maxWidth = 200,
}: {
  content: string;
  maxWidth?: number;
}) {
  return (
    <div
      style={{
        maxWidth: `${maxWidth}px`,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      <TooltipCoordinator
        condition={{ type: 'overflow' }}
        renderTooltip={() => <Tooltip>{content}</Tooltip>}
      >
        {content}
      </TooltipCoordinator>
    </div>
  );
}
